export default __webpack_public_path__ + "static/media/img-23-bruxo.08cb4efe.jpg";